var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form",
        { staticStyle: { margin: "40px auto 0" } },
        [
          _c(
            "result",
            {
              attrs: {
                title: _vm.language["system.changePwdSuccess"],
                "is-success": true
              }
            },
            [
              _c("div", { staticClass: "toLogin" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.language["system.will"])),
                  _c("span", [_vm._v(_vm._s(_vm.time))]),
                  _vm._v(_vm._s(_vm.language["system.returnLoginPage"]) + ".")
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }